export default __webpack_public_path__ + "static/media/bg.0312198a.png";